export default __webpack_public_path__ + "static/media/2253.90297e0e.png";